/**
 * StorageAdapter.ts - Base storage adapter interface
 * 
 * CHANGE HISTORY:
 * - 251027_2101 danielbeer: Move storage adapters from Actr to Aggregatr
 */
import type { EntityData, QueryFilters } from '../types/AggregatrTypes';

/**
 * Base storage adapter class
 * All storage implementations should extend this
 */
export abstract class StorageAdapter {
  abstract initialize?(): Promise<void>;
  abstract get(entityType: string, id: string): Promise<EntityData | null>;
  abstract set(entityType: string, id: string, data: EntityData): Promise<EntityData>;
  abstract delete(entityType: string, id: string): Promise<boolean>;
  abstract query(entityType: string, filters?: QueryFilters): Promise<EntityData[]>;
}

export default StorageAdapter;
